import { TableCell, TableRow } from '@mui/material'
import { Box, styled } from '@mui/system'

export const footerCellSx = {
  borderTop: '3px solid',
  borderTopColor: 'background.elevation8',
  borderBottom: '0px',
  color: 'text.base',
  backgroundColor: 'background.elevation1',
} as const

export const StyledFooterCell = styled(TableCell)(({ theme }) => ({
  borderTop: '3px solid',
  borderTopColor: theme.palette.background.elevation8,
  borderBottom: '0px',
  color: theme.palette.text.base,
  backgroundColor: theme.palette.background.elevation1,
}))

export const StyledHeaderCell = styled(TableCell)(({ theme }) => ({
  borderBottom: '3px solid',
  borderBottomColor: theme.palette.background.elevation8,
  color: theme.palette.text.basse,
  backgroundColor: theme.palette.background.elevation2,
  boxSizing: 'border-box',
}))

export const StyledStickyHeaderCell = styled(StyledHeaderCell)(({ theme }) => ({
  position: 'sticky',
  left: 0,
  backgroundColor: theme.palette.background.elevation1,
  padding: '8px !important',
  zIndex: 20,
}))

export const StickyCell = styled(TableCell)(({ theme }) => ({
  position: 'sticky',
  left: 0,
  backgroundColor: theme.palette.background.elevation1,
  padding: '8px',
  zIndex: 10,
}))

export const StyledBoxInStickyCell = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  borderRight: '1px solid',
  borderRightColor: theme.palette.background.elevation8,
  height: '100%',
  minHeight: '50px',
}))

export const StyledWorklogTableRow = styled(TableRow)(({ theme }) => ({
  color: theme.palette.text.base,
  backgroundColor: theme.palette.background.main,
  '&:hover': {
    backgroundColor: theme.palette.background.elevation3,
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.lightContrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.lightHover,
    },
    '& svg': {
      color: theme.palette.primary.lightContrastText,
    },
  },
  '&.holiday': {
    '&:not(.Mui-selected)': {
      color: theme.palette.accent.orange.text,
      svg: {
        color: theme.palette.accent.orange.text,
      },
      '&:hover': {
        color: theme.palette.accent.orange.textHover,
        svg: {
          color: theme.palette.accent.orange.textHover,
        },
      },
    },
  },
  '&.weekend': {
    '&:not(.Mui-selected)': {
      backgroundColor: theme.palette.background.elevation2,
      '&:hover': {
        backgroundColor: theme.palette.background.elevation3,
      },
    },
  },
  '&.holiday-weekend': {
    '&:not(.Mui-selected)': {
      color: theme.palette.accent.orange.text,
      backgroundColor: theme.palette.background.elevation2,
      svg: {
        color: theme.palette.accent.orange.text,
      },
      '&:hover': {
        color: theme.palette.accent.orange.textHover,
        backgroundColor: theme.palette.background.elevation3,
        svg: {
          color: theme.palette.accent.orange.textHover,
        },
      },
    },
  },
}))

export const StyledWorklogEntryTableRow = styled(TableRow)(({ theme }) => ({
  color: theme.palette.text.base,
  transition: 'all 150ms ease-in-out',
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.lightContrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.lightHover,
    },
    '& svg': {
      color: theme.palette.primary.lightContrastText,
    },
  },
  '&.holiday': {
    '&:not(.Mui-selected)': {
      color: theme.palette.accent.orange.text,
      svg: {
        color: theme.palette.accent.orange.text,
      },
      '&:hover': {
        color: theme.palette.accent.orange.textHover,
        svg: {
          color: theme.palette.accent.orange.textHover,
        },
      },
    },
  },
  '&.remote': {
    '&:not(.Mui-selected)': {
      backgroundColor: theme.palette.background.elevation2,
      color: theme.palette.text.base,
      '&:hover': {
        backgroundColor: theme.palette.background.elevation3,
      },
    },
  },
}))
